import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Card } from '@/common/components/Card/Card';
import { Heading } from '@/common/components/Heading/Heading';
import { Icon } from '@/common/components/Icons/Icon';
import { ModalDiscount } from '@/common/components/ModalDiscount/ModalDiscount';
import { Stack } from '@/common/components/Stack/Stack';
import { TaxDownLogoAsset } from '@/common/components/TaxDownPartnershipBannerCard/TaxDownLogoAsset';
import { IDiscount } from '@/common/integrations/menhir/employee/discounts/discounts.types';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';

export function TaxDownPartnershipBannerCard({
  discount,
}: TTaxDownPartnershipBannerCardProps) {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      {modalOpen && (
        <ModalDiscount
          discount={discount}
          onClose={() => setModalOpen(false)}
        />
      )}
      <Card
        onPress={() => {
          setModalOpen(true);
          AnalyticsService.trackCustomEvent('dashboard_taxdown_partnership_banner_card_clicked');
        }}
        className="cursor-pointer p-0 md:p-0"
        backgroundColor="accentPrimary20"
      >
        <Stack justify="between" horizontal>
          <Stack gap="2xs" className="shrink p-md md:p-lg">
            <Heading level={5}>
              {t('wallet.discounts.1_taxdown.banner.title')}
            </Heading>
            <BodyText size="sm">
              {t('wallet.discounts.1_taxdown.banner.description')}
            </BodyText>
          </Stack>
          <Stack gap="sm" align="center" className="shrink-0 px-md" horizontal>
            <TaxDownLogoAsset />
            <Icon icon="chevron-right" />
          </Stack>
        </Stack>
      </Card>
    </>
  );
}

export type TTaxDownPartnershipBannerCardProps = {
  discount: IDiscount;
};
